import { fetchWrapper } from '@/helpers';

const localApiUrl = process.env.VUE_APP_PROXY_SERVER + '/api/SystemConfig';

class SystemApi {
  async getSystemConfigList() {
    return fetchWrapper.get(localApiUrl + '/GetSystemConfigKeyList');
  }

  async getAllSystemConfig() {
    return fetchWrapper.get(localApiUrl + '/AllSystemConfig');
  }

  async getSystemConfigByKey(key) {
    return fetchWrapper.get(localApiUrl + '/GetSystemConfigByKey?key=' + key);
  }

  async updateSystemConfig(systemConfig) {
    return fetchWrapper.post(localApiUrl + '/UpdateSystemConfig', systemConfig);
  }
}

export default SystemApi;
